import { useSelector } from 'react-redux';

import SpotifyWebApi from 'spotify-web-api-node';
import { useDispatch } from 'react-redux';
import { setRecentPlaylist } from 'actions/action';
import AppInstance from 'utils/instance';

const useRecentPlaylits = () => {
  const dispatch = useDispatch();
  const webApi = new SpotifyWebApi();

  const token = AppInstance.getAccessToken();

  webApi.setAccessToken(token.access_token);

  const getRecentPlaylits = async () => {
    dispatch(
      setRecentPlaylist({
        isLoading: true,
        isError: false,
        data: null,
      })
    );
    try {
      const data = await webApi.getMyRecentlyPlayedTracks({ limit: 4 });
      dispatch(
        setRecentPlaylist({
          isLoading: false,
          isError: false,
          data: data.body,
        })
      );
    } catch (error) {
      AppInstance.removeAccessToken();
      dispatch(
        setRecentPlaylist({
          isLoading: false,
          isError: true,
          data: null,
        })
      );
    }
  };

  return { getRecentPlaylits };
};

export default useRecentPlaylits;
